<template>
  <div class="yearBag">
    <div class="yearBagHeader">
      <div class="headerImg">
      </div>
    </div>
    <div class="yearBagContent">
      <div class="contentIcon">
        年包兑换
      </div>
      <div class="contentBg">
        <div class="contentBar">
          <img :src="avatar" alt="" class="barHeader">
          <input type="text" v-model="nickname" readonly>
          <!-- <span></span> -->
          <!-- <span @click="phone = null"></span> -->
        </div>
        <div class="contenImg">
          <img src="../../assets/img/youkuCard/imgYouKu2.png" alt="">
          <span>优酷年包，本月领取</span>
        </div>
        <div class="contentText" v-if="timeYearBag">
          <span>距下次领取：</span>
          <span>仅剩 {{time}}天</span>
          <span :class="[time>0 ? 'graySpan': 'orangeSpan'  ]">/立即领取</span>
        </div>
        <div class="contentInput">
          <input class="inputPhone" type="text" placeholder="输入可验证码手机号" v-model="phone">
          <input class="inputBtn" type="button" value="点击兑换" @click="exchange()" :disabled="btnDisabled">
        </div>
      </div>

      <div class="contentDescribe">
        <div class="describeTitle">包年使用说明</div>
        <div class="describe">
          <!-- <p v-for="item in describe" :key="item" >{{item}} </p> -->
          <p>1、自动到账:抢购超低优酷会员年包成功后,权益将在5分钟内自动充值到您的手机号码上</p>
          <p>2、<span class="red">按月领取</span>:根据您的需求,按月自动领取会员</p>
          <p>3、登录使用:领取成功后,使用手机号码登录优酷视AP/官网,即可享受会员权益了</p>
          <p>4、权益说明:热剧抢先看,独家特供,免广告,1080p,极速存等</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Param from '../../assets/js/Param.js'
import { Dialog, Notify } from "vant";
export default {
  data() {
    return {
      Icon: [
        {imgUrl:require('../../assets/img/youkuCard/icon1.png'), imgText: '抢购年包'},
        {imgUrl:require('../../assets/img/youkuCard/icon2.png'), imgText: '年包兑换'},
        {imgUrl:require('../../assets/img/youkuCard/icon3.png'), imgText: '兑换码兑换'}
      ],
      Bg: [
        {imgUrl:require('../../assets/img/youkuCard/bg1.png')}
      ],
      describe: [
        '1、自动到账:抢购超低优酷会员年包成功后,权益将在5分钟内自动充值到您的手机号码上',
        '2、按月领取:根据您的需求,按月自动领取会员',
        '3、登录使用:领取成功后,使用手机号码登录优酷视AP/官网,即可享受会员权益了',
        '4、权益说明:热剧抢先看,独家特供,免广告,1080p,极速存等'
      ],
      avatar: localStorage.getItem('avatar'),
      timeYearBag: null,
      phone: null,
      time: 0,
      nickname: '昵称：' + localStorage.getItem('nickname') || '',
      btnDisabled: false
    }
  },
  created() {
  },
  methods: {
    exchange() {
      if (!this.phone) {
        Notify({message: '请输入您的手机号'});
        return false;
      } 
      if (!(/^(13[0-9]|14[5679]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/).test(this.phone)) {
        Notify({message: '请输入正确的手机号'});
        return false;
      }
      this.btnDisabled = true
      this.$http.post('/test/v1/yk-vip-annual-package/exchange?' + Param.init().re(), {
        account: this.phone
      }, {
				emulateJSON: true
			}).then(res => {
        this.btnDisabled = false
        if (res.data.error == 0) {
          Dialog.alert({
            message: '兑换成功'
          })
          this.timeYearBag = true 
        }else if (res.data.error == 40018) {
          Dialog.alert({
            message: res.data.msg
          })
          this.time = this.exchangeTime(res.data.data.exchange_time)
          this.timeYearBag = true
        } else {
          Dialog.alert({
            message: res.data.msg
          })
        }
      })

    },
    exchangeTime(time) {
      //时间戳为秒
      let distance= time - Date.parse(new Date())/1000
      if (distance <= 0) return 0
      let days = Math.floor(distance / (24 * 3600))
      return days
    }
  }
}
</script>

<style scoped lang="less">
  .yearBag {
    width: 100%;
    height: 100%;
    background: #FF6D22;
    .yearBagHeader {
      display: inline-block;
      width: 100%;
      height: 2.5rem;
      display: flex;
      align-items: center;
      justify-content: center;
      .headerImg {
        width: 95%;
        height: 2.5rem;
        background: url("../../assets/img/youkuCard/yearBagImg.png");
        background-size: 100% 100%;
      }
    }
    .yearBagContent {
      display: inline-block;
      width: 100%;
      background: #FF9348;
      box-sizing: border-box;
      .contentIcon {
        width: 35%;
        margin: .1rem auto 0 auto;
        height: .6rem;
        background: url("../../assets/img/youkuCard/yearBagIcon.png");
        background-size: 100% 100%;
        font-size: .36rem;
        color: #FFFFFF;
        letter-spacing: 2px;
        text-align: center;
        line-height: .7rem;
      }
      .contentBg {
        width: 90%;
        background: #FFFFFF;
        border-radius: 20px;
        margin: 0 auto;
        .contentBar {
          display: flex;
          width: 88%;
          margin: 0 auto;
          align-items: center;
          box-sizing: border-box;
          padding: .4rem .5rem 0 .5rem;
          img {
            width: .78rem;
            height: .78rem;
            border-radius: 50%;
            background: #CCCCCC;
          }
          input {
            width: 60%;
            height: .55rem;
            border: 2px solid #FF9348;
            border-radius: 20px;
            margin: 0 .3rem;
            font-size: .22rem;
            color: #FF9348;
            text-align: center;
          }
          // span:nth-child(3) {
          //   display: block;
          //   width: .5rem;
          //   height: .5rem;
          //   background: url("../../assets/img/youkuCard/right.png");
          //   background-size: 100% 100%;
          // }
          span:nth-child(3) {
            display: block;
            width: .6rem;
            height: .6rem;
            background: url("../../assets/img/youkuCard/error.png");
            background-size: 100% 100%;
          }
        }
        .contenImg {
          width: 70%;
          margin: .2rem auto 0 auto;
          padding: .2rem;
          display: flex;
          flex-direction: column;
          align-items: center;
          border-radius: 10px;
          box-shadow: 0px -2px 15px rgba(0, 0, 0, 0.16);
          img {
            width: 2.44rem;
            height: 1.84rem;
          }
          span {
            font-size: .28rem;
            color: #000;
            font-size: 600;
          }
       
        }
        .contentText {
          width: 70%;
          margin: 0 auto;
          font-size: .24rem;
          padding: .2rem 0 0 0;
          span:nth-child(1) {
            color: #949494;
          }
          span:nth-child(2) {
            color: #FF6D22;
          }
          .graySpan {
            color: #CCCCCC;
          }
          .orangeSpan {
            color: #FF6D22;
          }
        }
        .contentInput {
          width: 78%;
          margin: .2rem auto 0 auto;
          .inputPhone {
            width: 100%;
            height: .8rem;
            border-radius: 20px;
            border: 1px solid #FF6D22;
            margin: .1rem 0;
            text-align: center;
            color: #FF6D22;
            font-size: .30rem;
          }
          .inputBtn {
            width: 100%;
            height: .8rem;
            border-radius: 20px;
            background: #FF6D22;
            border: 0;
            margin: .1rem 0;
            color: #FFFFFF;
            font-size: .30rem;
            font-weight: 600;
            letter-spacing: 1px;
          }
        }
      }

      .contentDescribe {
        width: 88%;
        margin: .2rem auto 0 auto;
        .describeTitle {
          width: 45%;
          margin: 0 auto;
          background: #FFAA00;
          border-radius: 20px;
          height: .55rem;
          color: #FFFFFF;
          font-size: .3rem;
          text-align: center;
          line-height: .55rem;
        }
        .describe {
          width: 100%;
          font-size: .27rem;
          padding: 0 .3rem 0 .3rem;
          box-sizing: border-box;
          color: #FFFFFF;
          p {
            margin-top: 0.15rem;
            .red {
              color: #f44336;
            }
          }
        }
      }
    }
  }
  input[type=button]{-webkit-appearance: none;}
  input::-webkit-input-placeholder{
    color: #FF6D22;
  }    /* 使用webkit内核的浏览器 */
  input::-moz-placeholder{
    color: #FF6D22;
  }                  /* Firefox版本4-18 */
  input::-moz-placeholder{
    color: #FF6D22;
  }                  /* Firefox版本19+ */
  input::-ms-input-placeholder{
    color: #FF6D22;
  }
</style>


// WEBPACK FOOTER //
// src/components/youKu/yearBag.vue